// Generated by tailwind.css from stc/tailwind.css
import "./static/css/index.css";
